<ng-template #checkboxTemplate>
  <label
    [class.ant-table-selection-select-all-custom]="dwShowRowSelection"
    dw-checkbox
    [(ngModel)]="dwChecked"
    [dwDisabled]="dwDisabled"
    [dwIndeterminate]="dwIndeterminate"
    (ngModelChange)="dwCheckedChange.emit($event)">
  </label>
</ng-template>
<div class="ant-table-selection" *ngIf="dwShowRowSelection">
  <ng-container *ngIf="dwShowCheckbox">
    <ng-template [ngTemplateOutlet]="checkboxTemplate"></ng-template>
  </ng-container>
  <dw-dropdown dwPlacement="bottomLeft">
    <div dw-dropdown class="ant-table-selection-down">
      <i class="anticon anticon-down"></i>
    </div>
    <ul dw-menu class="ant-table-selection-menu">
      <li dw-menu-item *ngFor="let selection of dwSelections" (click)="selection.onSelect()">{{selection.text}}</li>
    </ul>
  </dw-dropdown>
</div>
<ng-container *ngIf="dwShowCheckbox && !dwShowRowSelection">
  <ng-template [ngTemplateOutlet]="checkboxTemplate"></ng-template>
</ng-container>
<ng-content></ng-content>
<div class="ant-table-column-sorter" *ngIf="dwShowSort">
      <span
        class="ant-table-column-sorter-up"
        [class.on]="dwSort == 'ascend'"
        [class.off]="dwSort != 'ascend'"
        title="↑"
        (click)="setSortValue('ascend')">
        <i class="anticon anticon-caret-up"></i>
      </span>
  <span
    class="ant-table-column-sorter-down"
    [class.on]="dwSort == 'descend'"
    [class.off]="dwSort != 'descend'"
    title="↓"
    (click)="setSortValue('descend')">
        <i class="anticon anticon-caret-down"></i>
      </span>
</div>
<dw-dropdown dwTrigger="click" *ngIf="dwShowFilter" [dwClickHide]="false" [hasFilterButton]="true" (dwVisibleChange)="dropDownVisibleChange($event)">
  <i class="anticon anticon-filter" [class.ant-table-filter-selected]="hasFilterValue" dw-dropdown></i>
  <ul dw-menu>
    <ng-container *ngIf="dwFilterMultiple">
      <li dw-menu-item *ngFor="let filter of multipleFilterList" (click)="checkMultiple(filter)">
        <label dw-checkbox [ngModel]="filter.checked"></label><span>{{filter.text}}</span>
      </li>
    </ng-container>
    <ng-container *ngIf="!dwFilterMultiple">
      <li dw-menu-item *ngFor="let filter of singleFilterList" (click)="checkSingle(filter)">
        <label dw-radio [ngModel]="filter.checked">{{filter.text}}</label>
      </li>
    </ng-container>
  </ul>
  <div class="ant-table-filter-dropdown-btns">
    <a class="ant-table-filter-dropdown-link confirm" (click)="hideDropDown()">
      <span (click)="search()">{{'Table.filterConfirm' | dwI18n}}</span>
    </a>
    <a class="ant-table-filter-dropdown-link clear" (click)="hideDropDown()">
      <span (click)="reset()">{{'Table.filterReset' | dwI18n}}</span>
    </a>
  </div>
</dw-dropdown>